<a class="btn btn-success m-btn m-btn--custom m-btn--icon" (click)="showModal()">
  <span>
    {{ 'contract-new.addTreaty' | transloco }}
  </span>
</a>

<ng-template #templateRef let-modal>
  <div class="modal-header">
    <h3 class="modal-title" *ngIf="!id">{{ 'contract-new.addTreaty' | transloco }}</h3>
    <h3 class="modal-title" *ngIf="id">{{ 'contract-new.editingTreaty' | transloco }}{{ id }}</h3>
    <button class="close" type="button" (click)="modal.dismiss()">
      <span>×</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="isLoading.form">
    <div class="m-page-loader m-page-loader--non-block m-page-loader--relative">
      <div class="m-loader m-loader--brand"></div>
    </div>
  </div>

  <div class="modal-body" *ngIf="!isLoading.form">
    <form class="m-form m-form--state m-form--label-align-right" [formGroup]="contractForm"
          (ngSubmit)="onSubmitForm(modal)">
      <div class="m-portlet__body" *ngIf="contractForm">
        <div class="m-form__section m-form__section--first m-form--label-align-right">
          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12 is--required">
              {{ 'contract-new.organization' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <app-organization-select formControlName="organizationId"></app-organization-select>
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12 is--required">
              {{ 'contract-new.supplier' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <app-suppliers-search [organizationId]="contractForm.controls.organizationId.value"
                                    formControlName="supplierId"></app-suppliers-search>
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12">
              {{ 'contract-new.bank' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <app-bank-search [id]="contractForm.controls.bankId.value" (update)="updateBank($event)"></app-bank-search>
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12">
              {{ 'contract-new.account' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <input type="text" formControlName="iban" class="form-control m-input" placeholder="">
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12 is--required">
              {{ 'contract-new.number' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <input type="text" formControlName="number" class="form-control m-input" placeholder="">
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12 is--required">
              {{ 'contract-new.date' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <hx-date-select formControlName="date"></hx-date-select>
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12">
              {{ 'contract-new.name' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <input type="text" formControlName="title" class="form-control m-input" placeholder="">
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12 is--required">
              {{ 'contract.currency' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <hx-enum-select [enumType]="currencies" [enumName]="'Currency'" formControlName="currency"></hx-enum-select>
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12">
              {{ 'contract.dueDays' | transloco }}:
            </label>
            <div class="col-lg-2 col-md-2 col-sm-6">
              <input type="number" formControlName="dueDays" class="form-control m-input" placeholder="">
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12">
              {{ 'contract-new.file' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <hx-file-list [fileList]="fileList" (fileRemove)="onFileRemoved($event)"></hx-file-list>

              <hx-file-upload (updateFiles)="onFilesUpdated($event)" [size]="5"
                              [folder]="folderContract"></hx-file-upload>
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12">
              {{ 'contract-new.note' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <input type="text" formControlName="note" class="form-control m-input" placeholder="">
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer modal-footer--pad-right">
        <button type="submit" class="btn btn-success">
          {{ 'btn.save' | transloco }}
        </button>

        <button type="button" (click)="closeModal(modal)" class="btn btn-secondary">
          {{ 'btn.cancel'| transloco }}
        </button>
      </div>
    </form>
  </div>
</ng-template>
